<template>
  <div>
    <b-row>
      <b-col
        md="12"
        xl="12"
      >
        <b-card
          :style="{ backgroundImage: `url(${banner})`, backgroundSize: 'cover' }"
          text-variant="white"
        >
          <b-card-text style="margin-top: -1vh;">
            <div class="d-flex card-banner-content">
              <b-row class="col-12">
                <b-col cols="12" md="6" lg="8">
                  <div class="card-title text-white pt-2 pl-2 mb-2">
                    {{ $route.meta.breadcrumb[1].text }}
                  </div>
                  <p class="pl-2" v-if="$route.meta.breadcrumb[1].text == 'Segmentation'">
                    Pengelompokan produk dalam katalog berdasarkan kategori, tipe, fitur, atau kebutuhan pasar tertentu
                  </p>
                  <p class="pl-2" v-else-if="$route.meta.breadcrumb[1].text == 'Targeting'">
                    Proses menentukan segmen pasar atau kelompok pelanggan tertentu yang menjadi sasaran utama untuk suatu kelompok produk dalam katalog
                  </p>
                </b-col>
                <!-- <b-col cols="12" md="6" lg="4" class="p-0">
                  <video
                    v-show="currentVideo"
                    controls
                    preload="auto"
                    :src="currentVideo"
                    class="w-100"
                    style="border-radius: 20px;"
                  />
                </b-col> -->
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="mb-2">
        <h5 class="subTit">{{ $route.meta.breadcrumb[1].text }} List</h5>
      </b-col>
    </b-row>
    
    <b-row>
      <b-col v-for="(val, key) in productArr" :key="val.KODE" xs="12" md="6" lg="4" xl="3" class="d-flex flex-column">
        <ProductCard :item="val" />
      </b-col>
      <b-col v-show="loading" v-for="i in 5" :key="i" xs="12" md="6" lg="4" xl="3">
        <ProductCardSkeleton />
      </b-col>
      <b-col class="text-center" v-if="!productArr.length && !loading">
        <b-card>
          <b-card-text>
            <h3 class="text-muted">No Data, please select another Product STP</h3>
          </b-card-text>
        </b-card>
      </b-col>

    </b-row>
    <b-row v-if="canLoadMore">
      <b-col>
        <b-button @click="fetchProduct" variant="warning" style="width: 100%;">
          Load more
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BSpinner,BRow, BCol, BCard, BLink, BCardText, BCardTitle, BCardSubTitle, BDropdown, BDropdownItem , BButton, BModal
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ProductCard from '@/views/user/product/components/ProductCardSTP.vue'
import ProductCardSkeleton from '@/views/user/product/components/ProductCardSkeleton.vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import { generateToken } from '@/auth/helperAuth'

export default {
  components: {
    BSpinner,
    BRow,
    BCol,
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BCardSubTitle,
    BButton,
    BDropdown,
    BDropdownItem,
    BModal,
    ProductCard,
    ProductCardSkeleton,
    FeatherIcon
},
  directives: {
    Ripple,
  },
  data() {
    return {
      token:"",
      banner: require('@/assets/images/product_banner-old.png'),
      icons: [
        'ChevronRightIcon'
      ],
      productArr: [],
      stp: '',
      segment: '',
      target: '',
      loading: true,
      currentPos: 1,
      canLoadMore: false,
      isDropdown2Visible: false,
    }
  },
  
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    };
    this.token = generateToken(payload)
    this.resetProductData()
    this.setSTPFromRoute()
    this.fetchProduct()
  },
  watch: {
    '$route'(to, from) {
      this.setSTPFromRoute()
      this.resetProductData()
      this.fetchProduct()
    }
  },
  mounted() {
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if(bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = true;
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if(bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = false;
      }
      if(this.isDropdown2Visible) {
        bvEvent.preventDefault()
      }
    })
  },
  methods: {
    fetchProduct() {
      this.loading = true
      this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/product/list?stp=${this.stp}&page=${this.currentPos}&perPage=3`, {
        withCredentials: true,
        headers: {
          'Client-Device': 'browser',
          'Authorization': `${this.token}`,
        },
      }).then(({ data }) => {
        this.productArr = [...this.productArr, ...data.data]
        this.currentPos += 1
        if (this.productArr.length >= data.pagination.total) {
          this.canLoadMore = false
        } else {
          this.canLoadMore = true
        }
      })
      .finally(() => {
        this.loading = false
      })
    },
    resetProductData() {
      this.productArr = []
      this.currentPos = 1
      this.canLoadMore = false
    },
    setSTPFromRoute() {
      if (this.$route.meta.breadcrumb[1].text === 'Segmentation') {
        this.stp = 'Segmen'
      } else {
        this.stp = 'Target'
      }
    },
  },
}
</script>

<style lang="scss">
.subTit {
  font-weight: bold;
}

.card .card-title {
  font-size: 2em;
  color: black;
}

.card-subtitle {
  font-size: 0.8em;
  color: black !important;
}

.pTurunan {
  color: black !important;
  font-weight: 500;
}
.card-banner-content {
  & > video {
    width: auto;
    max-height: 200px;
    background-color: white;
  }
}
.button-product-tree {
  background-color: white !important;
  color: black !important;
  font-weight: 600 !important;
  padding: 0.3rem 1.2rem !important;
  /* border-color: black !important; */
  box-shadow: 0px 6px 10px 0px rgba(76, 73, 65, 0.00), 0px 4px 0px 0px rgba(76, 73, 65, 0.40); 
  margin-top: 20px;
}
.image-tree {
  margin: 0 auto;
  max-width: 100%;
  height: auto;
}
</style>

<style lang="scss">
@import '@core/scss/vue/pages/ui-feather.scss';
</style>